import { faDiceThree } from "@fortawesome/free-solid-svg-icons/faDiceThree";
export let iconDice = faDiceThree;
export function overwriteDice(icon) {
    iconDice = icon;
}
export default iconDice;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGljZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9kaWNlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUNBLE9BQU8sRUFBRSxXQUFXLEVBQUUsTUFBTSwrQ0FBK0MsQ0FBQztBQUU1RSxNQUFNLENBQUMsSUFBSSxRQUFRLEdBQUcsV0FBVyxDQUFDO0FBRWxDLE1BQU0sVUFBVSxhQUFhLENBQUMsSUFBb0I7SUFDaEQsUUFBUSxHQUFHLElBQUksQ0FBQztBQUNsQixDQUFDO0FBRUQsZUFBZSxRQUFRLENBQUMifQ==